// eslint-disable-next-line import/no-self-import
/**
 * Get the YouTube video Id from source Url.
 *
 * @param {string} src - The original YouTube Url.
 * @returns {string} - YouTube video Id.
 */
var getVideoId = function (src) {
  var _a;
  if (!src) {
    return '';
  }
  if (/v=/.test(src)) {
    var splitedString = src.split('v=');
    if (/&/.test(splitedString[1])) {
      return splitedString[1].split('&')[0];
    }
    return splitedString[1];
  }
  if (/youtu.be/.test(src)) {
    var splitedString = src.split('youtu.be/');
    return splitedString[1];
  }
  return ((_a = src.match(/[^/]+$/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
};
/**
 * Check if url is valid YouTube thumbnail image.
 *
 * @param {string} src - The original YouTube Url.
 * @returns {boolean} - Returns boolean depending on image size.
 */
var checkImgUrl = function (url) {
  var img = new Image();
  img.src = url;
  return img.height > 90;
};
/**
 * Get max resolution thumbnail.
 *
 * @param {string} src - The original YouTube Url.
 * @returns {string} - Returns best image resolution thumbnail link is available.
 */
var youTubeThumbnailImage = function (src) {
  if (!src) {
    return '';
  }
  var imgResolutions = ['maxresdefault.jpg', 'hqdefault.jpg', 'sddefault.jpg', 'mqdefault.jpg', 'default.jpg'];
  var videoId = getVideoId(src);
  var youTubeThumbnailLink = 'https://i1.ytimg.com/vi';
  var thumbnailUrl = imgResolutions
  // eslint-disable-next-line array-callback-return
  .map(function (imgResolution) {
    var url = "".concat(youTubeThumbnailLink, "/").concat(videoId, "/").concat(imgResolution);
    if (checkImgUrl(url)) {
      return url;
    }
  }).filter(function (url) {
    return typeof url !== 'undefined';
  });
  return thumbnailUrl[0] || '';
};
/**
 * Check if provided src is a valid YouTube Url.
 *
 * @param {string} src - url
 * @returns {boolean}
 */
var isYoutubeSource = function (src) {
  if (!src) {
    return false;
  }
  return /(www\.)youtube\./.test(src) || /youtu\.be/.test(src);
};
export { checkImgUrl, getVideoId, isYoutubeSource, youTubeThumbnailImage };